import { UPDATE_ACTION_BAR } from "state/ui/actionBar/actionBarActionTypes";

export const update = payload => {
  return {
    type: UPDATE_ACTION_BAR,
    payload
  };
};
